import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import LoadingIndicator from '../../../../layout/LoadingIndicator'
import SomethingWentWrongIndicator from '../../../../layout/SomethingWentWrongIndicator'
import ModalWindow from '../../../../layout/modalwindow/ModalWindow'
import { trackPromise } from 'react-promise-tracker'
import axios from 'axios'
import PercentOffBatchSetFormStyle from './css/PercentOffBatchSetFormStyle'
import { getProductsList } from '../../../../products/ProductsFunctions'
import { getProductsClassifications } from '../../../../reports/ReportsFunctions'

function usePercentOffBatchSetForm(props) {
  const { app } = props
  const [productsList, setProductsList] = useState([])
  const [productsClassifications, setProductsClassifications] = useState([])

  const updateProduct = async (product) => {
    let success = false
    document.getElementById('modal-window-footer').innerHTML = ''

    ReactDOM.render(
      <LoadingIndicator loading_message={`Updating product ${product._id}...`}/>,
      document.getElementById('modal-window-footer')
    )

    await trackPromise (
      axios.put(app.API_URI + `/products?product_id=${product._id}`, product)
        .then(result => {
          success = Boolean(result.data)
          ReactDOM.unmountComponentAtNode(document.getElementById('modal-window-footer'))
        })
        .catch(err => {
          ReactDOM.render(<SomethingWentWrongIndicator err={err} />, document.getElementById('modal-window-footer'))
        })
    )

    return (success)
  }

  useEffect(() => {
    const init = async () => {
      const tempHTML = document.getElementById('modal-window-footer').innerHTML
      const pl = await getProductsList(app)
      const pc = await getProductsClassifications(app)
      if (pl) setProductsList(pl)
      if (pc) setProductsClassifications(pc)
      if (pl && pc) document.getElementById('modal-window-footer').innerHTML = tempHTML
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    productsList: [productsList, setProductsList],
    productsClassifications: [productsClassifications, setProductsClassifications],
    updateProduct
  })
}

function PercentOffBatchSetForm(props) {
  const percentOffBatchSetForm = usePercentOffBatchSetForm(props)
  const productsList = percentOffBatchSetForm.productsList[0]
  const productsClassifications = percentOffBatchSetForm.productsClassifications[0]
  const { updateProduct } = percentOffBatchSetForm
  const [percentOff, setPercentOff] = useState({value: 0.00, remarks: ''})
  let selectedItem = useRef([])
  let selectedHeader = useRef([])
  const [update, setUpdate] = useState(false)

  function ClassificationsContainer(props) {
    const sortProductsByBrand = (prod) => {
      prod.sort((a, b) => {
        let x, y
        x = a.brand.toLowerCase()
        y = b.brand.toLowerCase()

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
      return (prod)
    }

    const products = sortProductsByBrand(productsList.filter(product => product.classification === props.classification))

    /** Item Header (select/check all) **/
    const onChangeCheckBoxSelectAll = (e) => onClickItemSelectAll(e)
    const onClickItemSelectAll = (e) => {
      const classification = e.target.closest('.table-container').querySelector('.classification').innerText
      const item = e.target.closest('.item')
      const parentContainer = item.parentNode
      const checkBoxes = parentContainer.querySelectorAll('input')

      // Remove all item with classification equal to selected classification
      selectedItem.current = selectedItem.current.filter(si => si.classification !== classification)

      // Get the first checkbox which is checkbox header
      const check = checkBoxes[0].checked
      if (!check) selectedHeader.current.push(classification)
      else selectedHeader.current = selectedHeader.current.filter(sh => sh !== classification)

      checkBoxes.forEach((cb, index)  => {
        cb.checked = !check
        // Don't include header (index == 0)
        if (cb.checked && index) selectedItem.current.push({ classification, id: cb.closest('.item').id })
      })

      setUpdate(!update)
    }

    /** Item **/
    const onChangeCheckBox  = (e) => onClickItem(e)
    const onClickItem = (e) => {
      const classification = e.target.closest('.table-container').querySelector('.classification').innerText
      const item = e.target.closest('.item')
      const cb = item.querySelector('input')

      cb.checked = !cb.checked

      if (cb.checked) {
        selectedItem.current.push({ classification, id: item.id })
      } else selectedItem.current = selectedItem.current.filter(si => si.id !== item.id)

      setUpdate(!update)
    }

    return (
      <div className='table-container'>
        <div><b>Classification:</b> <span className='classification'>{props.classification}</span></div>
        <table className='products-list-table'>
          <tbody>
            <tr className='item' onClick={onClickItemSelectAll}>
              <td>
                <input
                  onChange={onChangeCheckBoxSelectAll}
                  type='checkbox'
                  checked={Boolean(selectedHeader.current.find(sh => sh === props.classification))}
                />
              </td>
              <td><b>Item name</b></td>
              <td><b>Unit</b></td>
            </tr>
            {
              products.map(product => (
                product.units.map((unit, index) => {
                  const item = selectedItem.current.find(si => si.id === `${product._id}-${unit.id}`)
                  let item_check = false
                  if (item) item_check = Boolean(item.id)
                  return (
                    <tr key={index} id={`${product._id}-${unit.id}`} className='item' onClick={onClickItem}>
                      <td><input id={unit.id} type='checkbox' onChange={onChangeCheckBox} checked={item_check}/></td>
                      <td>{`${product.brand} ${product.name} ${product.description}`}</td>
                      <td>{unit.description}</td>
                    </tr>
                  )
                })
              ))
            }
          </tbody>
        </table>
      </div>
    )
  }

  const onClickApply = async (e) => {
    const showMessageBoxSuccess = () => {
      ReactDOM.render (
        <ModalWindow
          id='mw-child'
          header='Setting Item Percent Off Successful'
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              All selected item's were succussfully set.
            </div>
            <div className='button-container'>
              <button
                onClick={() => { props.cb('Apply') }}
                className='pospro-action-btn top-anchor'>
                Ok
              </button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('mw-parent')
      )
    }

    const showMessageBoxError = (message, field_id=null) => {
      ReactDOM.render (
        <ModalWindow
          id='mw-child'
          header={'Setting Item Percent Off Error'}
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              {message}
            </div>
            <div className='button-container'>
              <button 
                onClick={() => {
                  if (field_id) document.getElementById(field_id).focus()
                  ReactDOM.unmountComponentAtNode(document.getElementById('mw-parent'))
                }}
                className='pospro-action-btn top-anchor'>
                Ok
              </button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('mw-parent')
      )
    }

    // Validate the percent off's fields
    // check first if there are item(s) selected
    if (percentOff.value === 0) {
      showMessageBoxError("Percent off cannot be 0.", 'percent-off')
      return
    }

    // check percent off remarks if not empty
    if (percentOff.remarks === '') {
      showMessageBoxError("Percent off remarks is not optional, please add one.", 'percent-off-remarks')
      return
    }

    // check if there are items selected
    if (selectedItem.current.length === 0) {
      showMessageBoxError("No Item(s) were selected. Please select the Item(s) you want to set.")
      return
    }

    // if all is fine the continue here ...
    let success = false
    for (let si of selectedItem.current) {
      const product_id = si.id.split('-')[0]
      const product_unit_id = si.id.split('-')[1]
      const product = productsList.find(product => product._id === product_id)
      const product_unit = product.units.find(unit => unit.id === product_unit_id)

      product_unit.percent_off = percentOff.value
      product_unit.percent_off_remarks = percentOff.remarks

      success = await updateProduct(product)
    }

    // Show a courtesy notification messagebox here
    // and exit the window after clicking OK button on the messagebox
    if (success) showMessageBoxSuccess()
  }

  const onClickCancel = (e) => { props.cb('Cancel') }

  return (
    <React.Fragment>
      <div className='wrapper'>
        <div className='form-container'>
          <div className='input-container'>
            <label htmlFor='percent-off'>Percent Off</label>
            <div className='percent-off-input-container'>
              <input
                id='percent-off'
                type='number'
                value={percentOff.value}
                onChange={(e) => { setPercentOff({...percentOff, value: (e.target.value) ? parseFloat(e.target.value) : ''})}}
                className='top-anchor'
              />
            </div>
          </div>
          <div className='input-container'>
            <label htmlFor='percent-off-remarks'>Percent Off Remarks</label>
            <div className='percent-off-remarks-input-container'>
              <input
                id='percent-off-remarks'
                value={percentOff.remarks}
                onChange={(e) => { setPercentOff({...percentOff, remarks: e.target.value})}}
                type='text'
              />
            </div>
          </div>
        </div>
        <hr />
        <div className='products-list-container'>
        {
          productsClassifications.map((classification, index) => (
            <ClassificationsContainer key={index} classification={classification} />
          ))
        }
        </div>
        <hr />
      </div>
      <div className='action-button-container'>
        <button
          id='cancel-button'
          onClick={onClickCancel}
          className='pospro-action-btn'>
          Cancel
        </button>
        <button
          id='apply-button'
          onClick={onClickApply}
          disabled={!Boolean(selectedItem.current.length)}
          className={Boolean(selectedItem.current.length) ? 'pospro-action-btn bottom-anchor' : 'pospro-action-btn bottom-anchor disabled-button'}>
          Apply
        </button>
      </div>
      <PercentOffBatchSetFormStyle />
    </React.Fragment>
  )
}

export default React.memo(PercentOffBatchSetForm)